<template>
  <div>
 <PageAppBar>Query</PageAppBar> 
    <div class="page-content header-clear-small">
      <div class="card card-style">
        <div class="input-style has-icon input-style-1 input-required">
          <span>Query Title</span>
          <em>(required)</em>
          <label for="Prayer Request Title" style="text-align:left">Query Title</label>
          <input v-model="title"  type="text">
        </div>
        <div class="input-style has-icon input-style-1 input-required">
          <span style="margin-left:10px">Description: </span>
          <label for="Description" style="text-align:left">Description</label>
          <textarea v-model="body"  rows="5"></textarea>
        </div>
        <p class="btn btn-m btn-full rounded-s shadow-l bg-green1-dark text-uppercase font-900" @click="savePrayer">Send</p>
<!--        <p @click="savePrayer">Save</p>-->
      </div>
    </div>
 <FooterBar></FooterBar>    
  </div>
</template>

<script>
import PageAppBar from "@/components/PageAppBar";
import FooterBar from "@/components/FooterBar";
export default {
    name: "NewQuery",
    components: {FooterBar, PageAppBar},

}
</script>

<style>

</style>